module.exports = __webpack_public_path__ + "static/media/234.f199c35c.png";